import { pstyle } from "../lib/pstyle.js";

export default function Diagrams({ v }) {
  return (
    <div style={pstyle("padding:48px 44px 80px; max-width:1180px; margin:0 auto; display:flex; flex-direction:column; gap:26px;")}>
      <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
        <h1 style={pstyle("margin:0; font-size:32px; font-weight:600; letter-spacing:-0.025em;")}>Schémas de référence</h1>
        <p style={pstyle("margin:0; font-size:15px; color:oklch(0.5 0.015 60);")}>Topologies types à recopier. Cliquez une couche pour l'isoler et ouvrir la fiche.</p>
      </div>
      <div style={pstyle("display:flex; gap:8px; flex-wrap:wrap;")}>
        {v.diagramTabs.map((t, i) => (
          <button key={i} type="button" onClick={t.onClick} style={pstyle("font:inherit; font-size:13px; border-radius:999px; padding:6px 14px; cursor:pointer;", { border: "1px solid " + t.border, color: t.color, background: t.bg })}>{t.label}</button>
        ))}
      </div>
      <div style={pstyle("display:grid; grid-template-columns:minmax(0,1fr) 300px; gap:40px; align-items:start;")}>
        <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:10px; padding:34px 30px; display:flex; flex-direction:column; gap:0; background:oklch(0.995 0.003 85);")}>
          {v.diagramLayers.map((l, li) => (
            <div key={li} style={pstyle("display:flex; flex-direction:column; gap:0;", { opacity: l.opacity })}>
              <div style={pstyle("display:flex; align-items:center; gap:16px;")}>
                <span style={pstyle("width:104px; flex:none; font-family:'IBM Plex Mono', monospace; font-size:11px; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.53 0.015 60);")}>{l.name}</span>
                <div style={pstyle("flex:1; display:flex; gap:14px;")}>
                  {l.nodes.map((n, ni) => (
                    <button key={ni} type="button" onClick={n.onClick} style={pstyle("font:inherit; flex:1; border-radius:7px; padding:14px 10px; text-align:center; cursor:pointer; display:flex; flex-direction:column; gap:3px;", { border: "1px solid " + n.border, background: n.bg, color: n.color })}>
                      <span style={pstyle("font-size:13.5px;")}>{n.label}</span>
                      <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:10.5px; color:oklch(0.56 0.015 60);")}>{n.sub}</span>
                    </button>
                  ))}
                </div>
              </div>
              {l.hasLink && (
                <div style={pstyle("display:flex; align-items:center; gap:16px; height:40px;")}>
                  <span style={pstyle("width:104px; flex:none; font-family:'IBM Plex Mono', monospace; font-size:10.5px; text-align:right; color:oklch(0.62 0.015 60); line-height:1.3;")}>{l.linkLabel}</span>
                  <div style={pstyle("flex:1; display:flex; justify-content:space-around; height:100%;")}>
                    {l.risers.map((r, ri) => (
                      <span key={ri} style={pstyle("width:1px; height:100%; background:oklch(0.88 0.01 85);")}></span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div style={pstyle("display:flex; flex-direction:column; gap:16px;")}>
          <div style={pstyle("display:flex; flex-direction:column; gap:8px;")}>
            <span style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Légende</span>
            {v.diagramLegend.map((g, i) => (
              <button key={i} type="button" onClick={g.onClick} style={pstyle("background:none; border:none; border-bottom:1px solid oklch(0.96 0.006 85); text-align:left; width:100%; font:inherit; display:flex; gap:10px; align-items:flex-start; padding:8px 0; cursor:pointer;")}>
                <span style={pstyle("width:9px; height:9px; flex:none; margin-top:5px; border-radius:3px;", { background: g.dot })}></span>
                <div style={pstyle("display:flex; flex-direction:column; gap:2px;")}>
                  <span style={pstyle("font-size:13.5px;", { color: g.color })}>{g.name}</span>
                  <span style={pstyle("font-size:12px; line-height:1.5; color:oklch(0.57 0.015 60); text-wrap:pretty;")}>{g.desc}</span>
                </div>
              </button>
            ))}
          </div>
          <div style={pstyle("font-size:13px; line-height:1.7; color:oklch(0.42 0.015 60); text-wrap:pretty;")}>{v.diagramNote}</div>
          <button type="button" onClick={v.diagramArticle} style={pstyle("background:none; border:none; padding:0; font:inherit; font-size:13.5px; color:oklch(0.46 0.075 55); cursor:pointer;")}>{v.diagramArticleLabel}</button>
        </div>
      </div>
    </div>
  );
}
